export default __webpack_public_path__ + "media/images/computer-man-3-8c3ce9a5aecbd10b9a696e1433ad6876.png";